// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__Xvgsy","disabled":"styles_disabled__QAFs+","settingsIcon":"styles_settingsIcon__tIG6k"};